<template>
  <div class="c-accreditation">
    <template v-if="accreditationEntityIsNotEmpty">
      <!--      <el-row v-if="!isMobile" :gutter="24">-->
      <!--        <el-col :span="24">-->
      <!--          <h2>Данные по аккредитации</h2>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <accreditation-master-approve
        v-if="idIsValid(entityId)"
        :entity="accreditationEntity"
        :link-by-rel="linkByRel"
        :prefixes="prefixes"
        @update="update"
      />
      <accreditation-approve
        v-if="menu"
        :entity="accreditationEntity"
        :link-by-rel="linkByRel"
        :prefixes="prefixes"
        @update="update"
      />
    </template>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import {
  buttonsDescriptions,
  checkFailStatuses,
  denyAccreditationMessages,
} from './statusDescription'
import { mapGetters } from 'vuex'
import AccreditationApprove from './AccreditationApprove'
import AccreditationMasterApprove from './AccreditationMasterApprove'
const Approvements = RepositoryFactory.get('approvements')

import * as _ from 'lodash'
const initStatusId = 0
const denySelectorName = '.el-message-box .el-input__inner'

export default {
  components: {
    AccreditationMasterApprove,
    AccreditationApprove,
  },
  provide() {
    return {
      permitToSeeActions: this.permitToSeeActions(),
      createListOfButtons: this.createListOfButtons,
      defaultButtons: this.defaultButtons,
      initStatusId,
    }
  },
  props: {
    entityId: {
      type: Number,
      default: 0,
      required: true,
    },
    linkByRel: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      prefixes: {},
      handler: null,
    }
  },
  computed: {
    ...mapGetters({
      getAutosById: 'autos/getAutosById',
      getContragentById: 'getContragentById',
      getDriversById: 'drivers/getDriversById',
      getUserOrganizationByid: 'userOrganizations/getUserOrganizationById',
    }),
    idIsValid() {
      return id => _.isInteger(id) && id > 0
    },
    accreditationEntityIsNotEmpty() {
      return (
        this.accreditationEntity &&
        Boolean(Object.keys(this.accreditationEntity).length)
      )
    },
    accreditationEntity() {
      return this.handler ? this.handler.stateHandler(this.entityId) : {}
    },
    menu() {
      return (
        'master-approve' in this.accreditationEntity &&
        this.accreditationEntity['master-approve'] &&
        this.accreditationEntity['master-approve'].status === 1
      )
    },
  },
  watch: {
    entityId: {
      immediate: true,
      handler(value) {
        if (this.idIsValid(value)) {
          this.init()
        }
      },
    },
  },
  methods: {
    init() {
      let handlers = {
        automobiles: {
          prefixes: {
            titleList: 'автомобиля',
            title: 'Автомобиль',
          },
          stateHandler: this.getAutosById,
        },
        drivers: {
          prefixes: {
            titleList: 'водителя',
            title: 'Водитель',
          },
          stateHandler: this.getDriversById,
        },
        contragents: {
          prefixes: {
            titleList: 'контрагента',
            title: 'Контрагент',
          },
          stateHandler: this.getContragentById,
        },
        userOrganization: {
          prefixes: {
            titleList: 'Оранизации пользователя',
            title: 'Организация пользователя',
          },
          stateHandler: this.getUserOrganizationByid,
        },
      }

      this.handler = handlers[String(this.linkByRel)]

      if (!this.handler) {
        throw new Error('entity type is wrong')
      }
      this.prefixes = this.handler.prefixes
    },
    permitToSeeActions() {
      return (
        this.$canAction('see_master_approve_buttons', this.userInfo) ||
        Number(this.accreditationEntity.is_owner) === 1
      )
    },
    defaultButtons(status, buttons) {
      // кнопки: аккредитовать, отказать
      if ([0, 4].includes(Number(status))) {
        buttons.push(buttonsDescriptions.confirm, buttonsDescriptions.deny)
      }

      return buttons
    },
    createListOfButtons(status) {
      let { user_org_inn } = this.accreditationEntity
      let buttons = []

      if (
        !this.isAdminorCeoRole &&
        Number(this.cur_org_inn) !== Number(user_org_inn)
      ) {
        return buttons
      }

      if (this.isAdminOrCeoRole) {
        buttons = this.reconfirmButtons(Number(status), buttons)
        buttons = this.defaultButtons(status, buttons)

        if (Number(status) === 1) {
          // кнопка: убрать с проверки
          buttons.push(buttonsDescriptions.denyConfirm)
        }
      } else {
        buttons = this.reconfirmButtons(Number(status), buttons)
      }

      return buttons
    },
    reconfirmButtons(status, buttons) {
      // кнопки: обратно на проверку
      if (checkFailStatuses(status)) {
        buttons.push(buttonsDescriptions.reConfirm)
      }

      return buttons
    },
    updateApprovements({ params, additionalParams }) {
      Approvements.postApprovements(params)
        .then(
          ({ data }) => {
            this.$emit('updateStore', {
              approve: data,
              id: this.entityId,
              additionalParams,
            })
            this.init()
          },
          err => console.error(err),
        )
        .catch(({ response }) => {
          const { message } = response.data[0] || {
            message: 'Неизвестная ошибка сервера',
          }

          this.$alert(message)
        })
    },
    makeTitleList() {
      return denyAccreditationMessages.reduce((common, current) => {
        let { shortText, fullText } = current
        let temp = `<a href="#"
                    onClick="
                    let selector = document.querySelector('${denySelectorName}');
                    selector.value = '${fullText}';
                    selector.focus();
                    let keyupEvent = new Event('keypress');
                    selector.dispatchEvent(keyupEvent);
                    return false;
                    ">${shortText}</a>  |  `

        return common.concat(temp)
      }, `Введите причину отказа в аккредитации<br>`)
    },
    update(params, additionalParams = {}) {
      const updateParams = {
        params,
        additionalParams,
      }
      const willUpdateIsMaster =
        additionalParams.fieldToUpdate === 'approve_master' &&
        checkFailStatuses(params.status)

      if (willUpdateIsMaster) {
        let titleString = this.makeTitleList(),
          promptConfig = {
            confirmButtonText: 'Отказать в аккредитации',
            cancelButtonText: 'Закрыть',
            dangerouslyUseHTMLString: true,
            customClass: 'classPromptAccreditation',
          }

        this.$prompt(titleString, 'Подтверждение', promptConfig)
          .then(data => this.confirmDeny(data, updateParams))
          .catch(() => this.clearReasonDeny())
      } else {
        this.updateApprovements(updateParams)
      }
    },
    clearReasonDeny() {
      document.querySelector(`${denySelectorName}`).value = ''
    },
    confirmDeny() {
      // old params: (data, { params, additionalParams })
      //      let result = Object.assign({}, data, {
      //        value: document.querySelector(`${denySelectorName}`).value
      //      });
      //      let { action, value: comment } = result,
      //        handlers = {
      //          confirm: this.updateApprovements,
      //          cancel: params => ({})
      //        }[action]({ params: { ...params, ...{ comment } }, additionalParams });
      this.clearReasonDeny()
    },
  },
}
</script>

<style lang="scss">
.c-hidden {
  display: none !important;
}
.classPromptAccreditation {
  width: 800px !important;
}
.c-text {
  font-family: 'Rubik', Arial, sans-serif;
  color: #000000;

  &--medium {
    font-weight: 500;
  }

  &--color {
    &-primary {
      color: #409eff !important;
    }

    &-success {
      color: #67c23a !important;
    }

    &-warning {
      color: #e6a23c !important;
    }

    &-danger {
      color: #f56c6c !important;
    }

    &-info {
      color: #909399 !important;
    }
  }

  &--align {
    &-left {
      text-align: left !important;
    }

    &-center {
      text-align: center !important;
    }

    &-right {
      text-align: right !important;
    }
  }

  &--transform {
    &-upper {
      text-transform: uppercase;
    }
  }
}

.c-accreditation {
  &__card {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__wrapper {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: -12px;
    margin-right: -12px;

    &-title {
      flex-basis: calc(100% / 3);
      flex-shrink: 0;
      padding-left: 12px;
      padding-right: 12px;
      box-sizing: border-box;
    }

    &-btn {
      flex-basis: calc(100% / 3);
      flex-shrink: 0;
      padding-left: 12px;
      padding-right: 12px;
      box-sizing: border-box;

      .el-button + .el-button {
        margin-left: 0;
        margin-top: 10px;
      }
    }

    &-text {
      flex-basis: 100%;
      padding-left: 12px;
      padding-right: 12px;
      box-sizing: border-box;
    }

    &--double {
      flex-wrap: wrap;

      .c-accreditation {
        &__wrapper {
          &-title {
            flex-basis: 66.66%;
          }
        }
      }
    }

    &--quadruple {
      .c-accreditation {
        &__wrapper {
          &-title {
            flex-basis: 30%;
          }

          &-btn {
            flex-basis: 30%;

            &.el-col {
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-basis: 30%;

              .c-accreditation__btn {
              }
            }
          }
        }
      }
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    * {
      flex-basis: calc(50% - 5px);
      /*font-size: 18px;
                line-height: 17px;*/

      &:first-child {
        color: #606266;
      }
    }

    p {
      color: #d7d3d3;
      word-break: break-word;
    }
  }

  &__title {
    margin: 13px 0;
    font-family: 'Rubik', Arial, sans-serif;
    font-size: 18px;
    line-height: 17px;
    color: #000000;
    word-break: break-word;
  }

  &__list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  &__item {
    margin-bottom: 17px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__text {
    word-break: break-word;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__btn {
    font-family: 'Rubik', Arial, sans-serif;
    font-weight: 500;
    text-align: center;

    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    display: block;
    text-overflow: ellipsis;

    &--full {
      display: block;
      width: 100%;
      max-width: 100%;
    }
  }
}

@media (max-width: 1367px) {
  .c-accreditation {
    &__wrapper {
      flex-wrap: wrap;
      .c-accreditation {
        &__wrapper {
          &-title {
            flex-basis: 100%;
          }

          &-btn {
            flex-basis: 50%;
          }
        }
      }

      &--double {
        .c-accreditation {
          &__wrapper {
            &-title {
              flex-basis: 50%;
            }

            &-btn {
              flex-basis: 50%;
            }
          }
        }
      }

      &--quadruple {
        .c-accreditation {
          &__wrapper {
            &-btn {
              &.el-col {
                flex-basis: 100%;
              }
            }
          }

          &__btn {
            flex-basis: calc(50% - 12px);
          }
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .c-accreditation {
    &__header {
      display: block;
    }

    &__btn {
      margin-bottom: 10px;
    }

    &__wrapper {
      flex-wrap: wrap;

      &--quadruple {
        .c-accreditation {
          &__wrapper {
            &-btn {
              &.el-col {
                display: block;
              }
            }
          }

          &__btn {
            margin-right: 0;
            margin-left: 0;
          }
        }
      }

      .c-accreditation {
        &__wrapper {
          &-title {
            flex-basis: 100%;
          }

          &-btn {
            flex-basis: 100%;
          }
        }
      }
    }
  }
}
</style>
